module.exports = __webpack_public_path__ + "492684d34299c698e0aff42dd021b7d6.svg";